<template>
  <div class='h100vh-116'>
    <div class='h-mml-leftinputbox'>
      <div class='h-mml-inputbigbox'>
        <ejs-textbox :placeholder='SearchHolder' v-model='keywords'></ejs-textbox>
      </div>
    </div>
    <div class='h100-40'>
      <ne-list :ne-datas='neDataFiltered' :dev-datas='devDataFiltered'></ne-list>
    </div>
  </div>
</template>
<script>
import NeList from '@/components/mmlconfig/leftPanel/NeList.vue';

export default {
  name: 'left-panel',
  components: {
    NeList
  },
  data() {
    return {
      SearchHolder: this.$t('MML.searchHolder'),
      keywords: '',
      primaryNeDatas: [],
      primaryDevDatas: []
    };
  },
  computed: {
    neDataFiltered() {
      const trimedKeyWords = this.keywords.trim().toLowerCase();
      if (trimedKeyWords === '') {
        return this.primaryNeDatas;
      }
      return this.primaryNeDatas.filter(neData => (neData.name.toLowerCase().includes(trimedKeyWords) 
        || (neData.Subnet && neData.Subnet.toLowerCase().includes(trimedKeyWords))));
    },
    devDataFiltered() {
      const trimedKeyWords = this.keywords.trim().toLowerCase();
      if (trimedKeyWords === '') {
        return this.primaryDevDatas;
      }
      return this.primaryDevDatas.filter(devData => (devData.name.toLowerCase().includes(trimedKeyWords)
        || (devData.Subnet && devData.Subnet.toLowerCase().includes(trimedKeyWords))));
    }
  },
  created() {
    this.axios.get('/lte/ems/auth/queryAllNodesByAuth').then(res => {
      const nodeMap = res.data;
      const neInfoArr = nodeMap.NetElement.sort((a, b) => (a.equipmentId - b.equipmentId));
      neInfoArr.forEach(neInfo => {
        neInfo.name = `${neInfo.name.trim()}`;
        neInfo.toolTip = `${this.$t('MML.elementName')}${neInfo.name.trim()}\n${this.$t('MML.equipmentName')}${neInfo.equipmentName.trim()}`;
        if(neInfo.ip) {
          neInfo.toolTip += `\n${this.$t('MML.equipmentIp')}${neInfo.ip}`;
        }
        if(neInfo.Subnet) {
          neInfo.toolTip += `\n${this.$t('MML.subnetInfo')}${neInfo.Subnet}`;
        }
        neInfo.id = neInfo.id;
        neInfo.icon = `icon hero-icon ${neInfo.icon} h-pm-icon4mml`;
      });
      this.primaryNeDatas = neInfoArr;
      console.log(this.primaryNeDatas);
      const devInfoArr = nodeMap.Equipment.sort((a, b) => (a.equipmentId - b.equipmentId));
      devInfoArr.forEach(devInfo => {
        devInfo.name = devInfo.name.trim();
        devInfo.toolTip = `${this.$t('MML.equipmentName')}${devInfo.name.trim()}`;
        if(devInfo.ip) {
          devInfo.toolTip += `\n${this.$t('MML.equipmentIp')}${devInfo.ip}`;
        }
        if(devInfo.Subnet) {
          devInfo.toolTip += `\n${this.$t('MML.subnetInfo')}${devInfo.Subnet}`;
        }
        devInfo.id = devInfo.id;
        devInfo.icon = `icon hero-icon ${devInfo.icon} h-pm-icon4mml`;
      })
      this.primaryDevDatas = devInfoArr;
    });
  },
  methods: {
  }
};
</script>

<style>

</style>
